const CHAPTER_TITLE_LOWEST_SCALE = 66; // Value to represent a lowest scale for a Title Scale
const CHAPTER_TITLE_HIGHEST_SCALE = 100; // Value to represent the highest scale for a Title Scale

export {
    CHAPTER_TITLE_LOWEST_SCALE,
    CHAPTER_TITLE_HIGHEST_SCALE
};